<template>

<core-dropdown class="account" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

    <div class="account-button" v-on:click="onToggleClick">
        <core-avatar v-if="loggedin" type="session" class="account-avatar" />
        <div v-if="!loggedin" class="account-avatar"><i class="fa fa-user"></i></div>
        <div class="account-caret"><i class="fa fa-caret-down"></i></div>
    </div>

    <core-dropdown-list v-if="loggedin" class="account-options" theme="head" align="right" type="button" :caret="true">

        <core-dropdown-item v-if="!isViewingSelf" class="account-options-item" type="link" icon="user" text="Go to your profile" v-on:click.native="onProfileClick" />
        <core-dropdown-item class="account-options-item" type="divide" />
        <core-dropdown-item class="account-options-item" type="link" icon="cog" text="Settings" v-on:click.native="onSettingsClick" />
        <core-dropdown-item class="account-options-item" type="link" icon="rotate" text="Syncs" v-on:click.native="onSyncsClick" />
        <core-dropdown-item class="account-options-item" type="link" icon=" fa-brands fa-patreon" text="Patreon" v-on:click.native="onPatreonClick" />
        <core-dropdown-item class="account-options-item" type="link" icon="unlock" text="Change password" v-on:click.native="onPasswordClick" />

        <template v-if="$isMobile">

            <core-dropdown-item class="account-options-item" type="divide" />
            <core-dropdown-item class="account-options-item" type="link" icon="check-to-slot" text="Feature voting" v-on:click.native="onVotingClick" />
            <core-dropdown-item class="account-options-item" type="link" icon="flask" text="Early access" v-on:click.native="onEarlyClick" />

        </template>

        <core-dropdown-item class="account-options-item" type="divide" />
        <core-dropdown-item class="account-options-item" type="link" icon="sign-out-alt" text="Logout" v-on:click.native="onLogoutClick" />

    </core-dropdown-list>

    <core-dropdown-list v-if="!loggedin" class="account-options" theme="head" align="right" type="button" :caret="true">

        <core-dropdown-item class="account-options-item" type="link" icon="sign-in-alt" text="Login" v-on:click.native="onLoginClick" />
        <core-dropdown-item class="account-options-item" type="link" icon="user-plus" text="Register" v-on:click.native="onRegisterClick" />

        <template v-if="$isMobile">

            <core-dropdown-item class="account-options-item" type="divide" />
            <core-dropdown-item class="account-options-item" type="link" icon="check-to-slot" text="Feature voting" v-on:click.native="onVotingClick" />
            <core-dropdown-item class="account-options-item" type="link" icon="flask" text="Early access" v-on:click.native="onEarlyClick" />
            <core-dropdown-item class="account-options-item" type="link" icon=" fa-brands fa-patreon" text="Patreon" v-on:click.native="onPatreonClick" />

        </template>

    </core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

    data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

    computed: {
    
        isViewingSelf: function() {
        
            return this.$store.getters['session'].slug === this.$route.params.name && this.isUser
        
        }

    },

    methods: {

        onProfileClick: function() {
        
            this.$routerPush({
				name: 'Collection',
				params: {
					name: this.$store.getters['session'].slug,
					type: this.$CONSTANTS.TYPE.USERS
				}
			}).catch(function() {})

        },

        onPatreonClick: function() {
        
			this.$routerPush({
                name: (this.$loggedin) ? 'SessionPatreon' : 'CommunityPatreon'
            })

            this.is.expanded = false

        },

        onSyncsClick: function() {
        
			this.$routerPush({
                name: 'SessionSyncs'
            })

            this.is.expanded = false

        },

        onVotingClick: function() {

			this.$routerPush({
                name: (this.$isPatreon) ? 'SessionPatreonVoting' : 'CommunityVoting'
            })

        },

        onEarlyClick: function() {

			this.$routerPush({
                name: (this.$isPatreon) ? 'SessionPatreonAccess' : 'CommunityAccess'
            })

        },

        onSettingsClick: function() {
        
			this.$routerPush({
                name: 'SessionSettings'
            })

            this.is.expanded = false

        },

        onPasswordClick: function() {
        
			this.$pubsub.$emit('open.modal', 'userPassword')

            this.is.expanded = false

        },

        onLogoutClick: function() {
        
			this.$routerPush({name: 'Logout'}).catch(function(e) { console.log(e) })

        },

        onLoginClick: function() {
        
			this.$pubsub.$emit('open.modal', 'userLogin')

            this.is.expanded = false

        },

        onRegisterClick: function() {

            if (process.env.VUE_APP_TYPE === 'subdomain' || process.env.VUE_APP_TYPE === 'externaldomain') {

                window.location.href = 'https://geekgroup.app'

            } else {

                this.$pubsub.$emit('open.modal', 'userRegister')

                this.is.expanded = false    

            }

        },
    
        onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		}
    
    }

}

</script>

<style scoped>

.account {
    height: 64px;
    margin-right: 20px;
    margin-left: 10px;
}

.is-mobile .account {
    height: 48px;
    margin-left: 5px;
    margin-right: 10px;
}

.account-button {
    cursor: pointer;
    padding: 8px 0px;
    display: flex;
    align-items: center;
    height: 64px;
}

.is-mobile .account-button {
    height: 48px;
}

.account-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5);
    line-height: 40px;
    text-align: center;
    font-size: 20px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.5);
}

.is-mobile .account-avatar {
    height: 32px;
    width: 32px;
    line-height: 32px;
    font-size: 16px;
}

.account-caret {
    color: #fff;
    margin-left: 10px;
}

.is-mobile .account-caret {
    margin-left: 5px;
}

</style>
